import styled from "styled-components";

import color from "constants/color";

const Label = styled.span<{
  backgroundColor?: string;
  textColor?: string;
  fontWeight?: "normal" | "bold" | "semibold";
  fontSize?: string;
}>`
  display: flex;
  padding: 4px 5px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.backgroundColor || "#f0f0f0"};
  color: ${(props) => props.textColor || color.text.black};
  font-weight: ${(props) => props.fontWeight};
  font-size: ${(props) => props.fontSize || "14px"};
  min-width: 130px;
  flex: 1;
  min-height: 21px;
`;

const NoticeLabel = ({
  children,
  backgroundColor,
  textColor,
  fontWeight = "normal",
  fontSize,
}: {
  children: React.ReactNode;
  backgroundColor?: string;
  textColor?: string;
  fontWeight?: "normal" | "bold" | "semibold";
  fontSize?: string;
}) => (
  <Label backgroundColor={backgroundColor} textColor={textColor} fontWeight={fontWeight} fontSize={fontSize}>
    {children}
  </Label>
);

export default NoticeLabel;
